/**
 * Pending Edits Registry
 *
 * Editor components debounce their API syncs (typing, property tweaks). Anything that needs the
 * server to be up to date — saving, creating a checkpoint, leaving the editor — calls
 * `flushPendingEdits()` first so debounced edits are sent instead of silently dropped.
 */

type Flush = () => void;

const flushers = new Set<Flush>();

/**
 * Registers a flush callback. Returns an unregister function (call it on unmount, after flushing).
 */
export function registerPendingEdit(flush: Flush): () => void {
  flushers.add(flush);
  return () => {
    flushers.delete(flush);
  };
}

/**
 * Immediately runs every registered pending edit.
 */
export function flushPendingEdits(): void {
  for (const flush of Array.from(flushers)) {
    try {
      flush();
    } catch (error) {
      console.error("Failed to flush pending edit:", error);
    }
  }
}
